<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <div id="Benutzerautorisierung">
                <h2>{{ $t('userAuthorisation.Header') }}</h2>
                <div id="GridBenutzerautorisierung">
                    <Grid ref="gridBenutzerautorisierung"
                          :style="{ height: '600px' }"
                          :data-items="gridDataComputed"
                          :loader="loader"
                          :selected-field="selectedField"
                          @rowclick="onRowClicked"
                          :columns="columns">
                        <grid-toolbar>
                            <kbutton title="Autorisieren" :theme-color="'primary'" @click="onAutorisierenClick">
                                {{ $t('userAuthorisation.ButtonAuthorise') }}
                            </kbutton>
                            <kbutton title="Loeschen" :theme-color="'primary'" @click="onLoeschenClick">
                                {{ $t('userAuthorisation.ButtonDelete') }}
                            </kbutton>
                            <kbutton title="VereinAendern" :theme-color="'primary'" @click="onVereinAendernClick">
                                {{ $t('userAuthorisation.ButtonChangeClub') }}
                            </kbutton>
                            <combobox :style="{ width: '360px' }"
                                      :data-items="comboDataVereine"
                                      :text-field="'bezeichnung'"
                                      :data-item-key="'prim'"
                                      :value-field="'prim'"
                                      :value-primitive="true"
                                      @change="handleChangeVereine"
                                      :value="selectedPrimVereine"
                                      :filterable="true"
                                      @filterchange="filterChange"
                                      :placeholder="'Bitte Verein auswählen...'"
                                      v-model="selectedPrimVereine">
                            </combobox>
                        </grid-toolbar>
                        <grid-norecords>{{ $t('userAuthorisation.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
            </div>
            <NotificationGroup :style="{
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                'align-items': 'flex-start'
                }">
                <Fade :appear="successAutorisieren">
                    <Notification v-if="successAutorisieren" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationSaveAuthorise') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorAutorisieren">
                    <Notification v-if="errorAutorisieren" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationErrorAuthorise') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="successDelete">
                    <Notification v-if="successDelete" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationSaveDelete') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorDelete">
                    <Notification v-if="errorDelete" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationErrorDelete') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="successVereinAendern">
                    <Notification v-if="successVereinAendern" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationSaveClub') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorVereinAendern">
                    <Notification v-if="errorVereinAendern" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationErrorClub') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorVereinUnbekannt">
                    <Notification v-if="errorVereinUnbekannt" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('userAuthorisation.NotificationErrorUnknown') }}</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
        </div>
    </div>
</template>

<script>
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { filterBy } from '@progress/kendo-data-query';
    import config from "@/appdata/config.json";
    import axios from 'axios';
    import store from '@/store/store.js';

    export default {
        components: {
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'combobox': ComboBox,
            kbutton: Button,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                baseUrl: '',
                baseUrlSportlerfreigben: '',
                baseUrlVereine: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridData: [],
                gridDataSportlerfreigaben: [],
                gridDataVereine: [],
                updatedData: [],
                selectedField: "selected",
                selectedPrim: 0,
                selectedEMail: '',
                selectedVorname: '',
                selectedName: '',
                selectedNameStadtVerein: '',
                selectedPrimVereine: 0,
                selectedPrimNewVereine: 0,
                comboDataVereine: [],
                baseComboUrlVereine: config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineAuswahlManagement",
                patchurlAutorisieren: '',
                patchurlVereinAendern: '',
                deleteurlLoeschen: '',
                columns: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "eMail", editable: false, width: 200, title: this.$t('userAuthorisation.GridColumnHeaderEMail') },
                    { field: "name", editable: false, width: 150, title: this.$t('userAuthorisation.GridColumnHeaderName') },
                    { field: "vorname", editable: false, width: 150, title: this.$t('userAuthorisation.GridColumnHeaderFirstName') },
                    { field: "nameStadtVerein", editable: false, width: 450, title: this.$t('userAuthorisation.GridColumnHeaderClub') },
                    { field: "bemerkung", editable: false, width: 300, title: this.$t('userAuthorisation.GridColumnHeaderRemark') },
                    { field: "refVereine", editable: false, hidden: true, width: 100, title: "refVereine" },
                ],
                loader: false,
                successAutorisieren: false,
                errorAutorisieren: false,
                successDelete: false,
                errorDelete: false,
                successVereinAendern: false,
                errorVereinAendern: false,
                errorVereinUnbekannt: false,
                posturlMail: '',
                subjectMail: '',
                bodyMail: '',
            };
        },
        computed: {
            gridDataComputed() {
                return this.gridData.map((item) => ({ prim: item.prim, eMail: item.eMail, name: item.name, vorname: item.vorname, nameStadtVerein: item.nameStadtVerein, bemerkung: item.bemerkung, refVereine: item.refVereine, selected: (item.prim === this.selectedPrim) }));
            },
        },
        created: function () {
            if (store.istAdmin === true) {
                this.baseUrl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/BenutzerWaitAutorisierungManagement";
                this.getData();
                this.getDataComboVereine();
            }
        },
        methods: {
            onAutorisierenClick() {
                //Nur Vereine > 0 speichern
                if (this.selectedPrimVereine > 0) {
                    const parameters = {
                        "prim": this.selectedPrim
                    };
                    this.patchurlAutorisieren = config[0].ServiceUrl + config[0].ServiceUrlPort + "/UpdateBenutzerWaitAutorisierung"
                    axios.patch(this.patchurlAutorisieren, parameters)
                        .then((response) => {
                            console.log("----------> success", response);
                            //E-Mail versenden
                            //Mailtext aufbereiten
                            this.subjectMail = 'NWTU Anmelde System - (AUT) Autorisierung Ihres Benutzerkontos'
                            this.bodyMail = '(AUT) Autorisierung Ihres Benutzerkontos (for english version, please see below)<br /><br />'
                                + 'Hallo ' + this.selectedVorname + ', <br /><br />'
                                + 'vielen Dank für die Registrierung beim NWTU Anmelde System NAS! Wir haben folgende Daten erfasst:<br /><br />'
                                + 'Name:      ' + this.selectedName + '<br />'
                                + 'Vorname:   ' + this.selectedVorname + '<br />'
                                + 'E-Mail:    ' + this.selectedEMail + '<br />'
                                + 'Verein:    ' + this.selectedNameStadtVerein + '<br /><br />'
                                + 'Ihr Konto wurde aktiviert. Sie können sich jetzt für jedes der verfügbaren Turniere anmelden.<br /><br />'
                                + 'Vertraulichkeitserklärung: Diese E-Mail-Nachricht kann vertrauliche und vertrauliche Informationen enthalten und ist dazu bestimmt zur Nutzung durch die oben genannte natürliche oder juristische Person. Wenn Sie nicht der beabsichtigte Empfänger sind, beachten Sie, dass dies der Fall ist Offenlegung, Vervielfältigung, Verbreitung oder Nutzung des Inhalts dieser Nachricht ist untersagt. Wenn Sie diese Nachricht fälschlicherweise erhalten haben, benachrichtigen Sie bitte den Absender per Antwort-E-Mail und löschen Sie das Material von Ihrem Computer.<br /><br />'
                                + 'Turnier Organisation<br />'
                                + '<p>---------------------------------------------------</p>'
                                + '(AUT) Authorization of your account<br /><br />';
                                + 'Hello ' + this.selectedVorname + ', <br /><br />'
                                + 'many thanks for registering with NWTU Anmelde System NAS! We have recorded the following data from you:<br /><br />'
                                + 'Name:         ' + this.selectedName + '<br />'
                                + 'First name:   ' + this.selectedVorname + '<br />'
                                + 'eMail:        ' + this.selectedEMail + '<br />'
                                + 'Club:         ' + this.selectedNameStadtVerein + '<br /><br />'
                                + 'Your account has been activated. You can now subscribe for any of the available tournaments.<br /><br />'
                                + 'Confidentiality statement: this email message may contain confidential and privileged information and is intended to be for the use of the individual or entity named above. If you are not the intended recipient, be aware that any disclosure, copying, distribution, or use of the content of this message is prohibited. If you have received this message in error, please notify the sender by reply email and delete the material from your computer.<br /><br />'
                                + 'Tournament organization<br />'
                            //E-Mail Post
                            this.posturlMail = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Mail?receiver=" + this.selectedEMail + "&title=" + this.subjectMail + "&body=" + this.bodyMail + "&isHtml=true"
                            axios.post(this.posturlMail)
                                .then((response) => {
                                    console.log("----------> successMailAutorisierenErfolgt", response);
                                    this.showNotificationSuccessAutorisieren();
                                    this.getData();
                                    this.getDataComboVereine();
                                })
                                .catch((error) => {
                                    console.log("---------> errorMailAutorisierenErfolgt", error);
                                });
                        })
                        .catch((error) => {
                            console.log("---------> error", error);
                            this.showNotificationErrorAutorisieren();
                        });
                } else {
                    this.showNotificationErrorVereinUnbekannt();
                }
            },
            onLoeschenClick() {
                //Nur Vereine > 0 speichern
                if (this.selectedPrimVereine > 0) {
                    this.deleteurlLoeschen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteBenutzerWaitAutorisierung"
                    axios.delete(this.deleteurlLoeschen, { data: { prim: this.selectedPrim } })
                        .then((response) => {
                            console.log("----------> success", response);
                            //E-Mail versenden
                            //Mailtext aufbereiten
                            this.subjectMail = 'NWTU Anmelde System - (AUT) Ablehnung Autorisierung Ihres Benutzerkontos'
                            this.bodyMail = '(AUT) Ablehnung Autorisierung Ihres Benutzerkontos (for english version, please see below)<br /><br />'
                                + 'Hallo ' + this.selectedVorname + ', <br /><br />'
                                + 'ihre Registrierung wurde abgelehnt, da für diesen Verein, ' + this.selectedNameStadtVerein + ', bereits eine Autorisierung für eine Person vorliegt. Bitte wenden Sie sich mit Ihrem Anliegen zunächst an Ihren Vereinsvertreter.<br /><br />'
                                + 'Vertraulichkeitserklärung: Diese E-Mail-Nachricht kann vertrauliche und vertrauliche Informationen enthalten und ist dazu bestimmt zur Nutzung durch die oben genannte natürliche oder juristische Person. Wenn Sie nicht der beabsichtigte Empfänger sind, beachten Sie, dass dies der Fall ist Offenlegung, Vervielfältigung, Verbreitung oder Nutzung des Inhalts dieser Nachricht ist untersagt. Wenn Sie diese Nachricht fälschlicherweise erhalten haben, benachrichtigen Sie bitte den Absender per Antwort-E-Mail und löschen Sie das Material von Ihrem Computer.<br /><br />'
                                + 'Turnier Organisation<br />'
                                + '<p>---------------------------------------------------</p>'
                                + '(AUT) Reject authorization of your user account<br /><br />';
                                + 'Hello ' + this.selectedVorname + ', <br /><br />'
                                + 'your registration was rejected because an authorization for one person already exists for this club, ' + this.selectedNameStadtVerein + '. Please contact your club representative first with your concerns.<br /><br />'
                                + 'Confidentiality statement: this email message may contain confidential and privileged information and is intended to be for the use of the individual or entity named above. If you are not the intended recipient, be aware that any disclosure, copying, distribution, or use of the content of this message is prohibited. If you have received this message in error, please notify the sender by reply email and delete the material from your computer.<br /><br />'
                                + 'Tournament organization<br />'
                            //E-Mail Post
                            this.posturlMail = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Mail?receiver=" + this.selectedEMail + "&title=" + this.subjectMail + "&body=" + this.bodyMail + "&isHtml=true"
                            axios.post(this.posturlMail)
                                .then((response) => {
                                    console.log("----------> successMailLoeschenErfolgt", response);
                                    this.showNotificationSuccessAutorisieren();
                                    this.getData();
                                    this.getDataComboVereine();
                                })
                                .catch((error) => {
                                    console.log("---------> errorMailLoeschenErfolgt", error);
                                });
                            this.showNotificationSuccessDelete();
                            this.getData();
                        })
                        .catch((error) => {
                            console.log("---------> error", error);
                            this.showNotificationErrorDelete();
                        });
                } else {
                    this.showNotificationErrorVereinUnbekannt();
                }
            },
            onVereinAendernClick() {
                this.selectedPrimNewVereine = this.selectedPrimVereine;
                //Nur Vereine > 0 speichern
                if (this.selectedPrimNewVereine > 0) {
                    const parameters = {
                        "prim": this.selectedPrim,
                        "refVereine": this.selectedPrimNewVereine
                    };
                    this.patchurlVereinAendern = config[0].ServiceUrl + config[0].ServiceUrlPort + "/UpdateBenutzerWaitAutorisierungVerein"
                    axios.patch(this.patchurlVereinAendern, parameters)
                        .then((response) => {
                            console.log("----------> success", response);
                            this.showNotificationSuccessVereinAendern();
                            this.getData();
                        })
                        .catch((error) => {
                            console.log("---------> error", error);
                            this.showNotificationErrorVereinAendern();
                        });
                } else {
                    this.showNotificationErrorVereinUnbekannt();
                }
            },
            handleChangeVereine(event) {
                this.selectedPrimVereine = event.value;
            },
            onRowClicked(event) {
                this.selectedPrim = event.dataItem.prim;
                this.selectedPrimVereine = event.dataItem.refVereine;
                this.selectedVorname = event.dataItem.vorname;
                this.selectedName = event.dataItem.name;
                this.selectedEMail = event.dataItem.eMail;
                this.selectedNameStadtVerein = event.dataItem.nameStadtVerein;
            },
            getDataComboVereine: function () {
                this.selectedPrimVereine = null;
                this.baseComboUrl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineAuswahlManagement";
                this.comboDataVerein = [];
                const that = this;
                fetch(this.baseComboUrl, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataVereine = data;
                    });
            },
            getData: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrl,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.total = total;
                        that.updatedData = [].concat(data);
                        that.gridData = data;
                        this.loader = false;
                    });
            },
            filterChange(event) {
                this.comboDataVereine = this.filterData(event.filter);
            },
            filterData(filter) {
                const data = this.comboDataVereine.slice();
                return filterBy(data, filter);
            },
            showNotificationSuccessAutorisieren() {
                /*Meldung anzeigen*/
                this.successAutorisieren = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successAutorisieren = false;
                }, 3000);
            },
            showNotificationErrorAutorisieren() {
                /*Meldung anzeigen*/
                this.errorAutorisieren = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorAutorisieren = false;
                }, 3000);
            },
            showNotificationSuccessDelete() {
                /*Meldung anzeigen*/
                this.successDelete = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successDelete = false;
                }, 3000);
            },
            showNotificationErrorDelete() {
                /*Meldung anzeigen*/
                this.errorDelete = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorDelete = false;
                }, 3000);
            },
            showNotificationSuccessVereinAendern() {
                /*Meldung anzeigen*/
                this.successVereinAendern = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successVereinAendern = false;
                }, 3000);
            },
            showNotificationErrorVereinAendern() {
                /*Meldung anzeigen*/
                this.errorVereinAendern = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorVereinAendern = false;
                }, 3000);
            },
            showNotificationErrorVereinUnbekannt() {
                /*Meldung anzeigen*/
                this.errorVereinUnbekannt = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorVereinUnbekannt = false;
                }, 3000);
            },
            
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
